import useFetch from "../../server/useFetch";
import { Table } from "antd";
import { useEffect, useState } from "react";
import query from "../../server/constants.api";
import CustomIcon from "../Global/Icons/CustomIcon";
import Theme from "../../styles/Theme/Theme";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import { Text } from "../Global/Atomics/Text";
import Spinner from "../Global/Atomics/Spinner";
import { io } from "socket.io-client";
import { websocketPort } from "../../server/websocketPort";

const socket = io(websocketPort);
export const TableIncidentsWidget = (props) => {
    const { data: tableIncidentsData, isLoading: tableIncidentsIsLoading, refetch: refetchTableIncidents } = useFetch(query.path.tableIncidents, 'getTableIncidents');
    const [tableData, setTableData] = useState();
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });

        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
            setTableData([]);
        }
    };

    useEffect(() => {
        console.log('tableIncidentsData?.data', tableIncidentsData?.data);
        if(tableIncidentsData?.data){
            setTableData(tableIncidentsData?.data)
        }
    }, [tableIncidentsIsLoading, tableIncidentsData?.data])

    useEffect(() => {
        socket.on("manageIncident", (text) => {
            console.log("Refetch Incidents");
            refetchTableIncidents();
        });
    }, [])
    console.log('tableIncidentsIsLoading', tableIncidentsIsLoading);

    return (
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} justifyContent='space-between'>
            {!tableIncidentsIsLoading ?
                <>
                    <div style={{ display: "flex", alignItems: 'flex-end' }}>
                        <CustomIcon icon={'Clipboard'} iconSize='md' color={Theme.color['teal-4']} strokeWidth='1' />
                        <Text color={Theme.color['coolgray-12']} marginLeft='0.4vw' fontSize='text_md' fontWeight={Theme.typography.weight.medium}>{props?.block?.title}</Text>
                    </div>
                    <div style={{ width: '100%', height: '100%', marginTop: '20px' }}>
                        <Table
                            columns={columns}
                            rowKey={(record) => record.reference_number}
                            dataSource={tableData}
                            pagination={false}
                            // loading={isLoading}
                            onChange={handleTableChange}
                            className="tableIncidents"
                            style={{ width: '100%', height: '100%' }}
                        />
                    </div>
                </>
                : <div style={{ height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>}
        </WidgetCard>

    )
}

const columns = [
    {
        title: 'Priority',
        dataIndex: 'prioritylevel',
        sorter: false,
        render: (prioritylevel) => (<CustomIcon icon={"Dot"} iconSize='xs' color={defineColor(prioritylevel)}/>),
        width: '5%',
    },
    {
        title: 'Level',
        dataIndex: 'prioritylevel',
        sorter: true,
        width: '5%',
    },
    {
        title: 'Reference Number',
        dataIndex: 'reference_number',
        sorter: false,
        // render: (name) => `${name.first} ${name.last}`,
        width: '10%',
    },
    {
        title: 'Family',
        dataIndex: 'service_family',
        width: '10%',
    },
    // {
    //     title: 'City Service',
    //     dataIndex: 'city_service',
    //     width: '20%',
    // },
    {
        title: 'Location',
        dataIndex: 'location',
        width: '30%',
    },
    {
        title: 'Created Date',
        dataIndex: 'created_date',
        width: '20%',
    },
];

function defineColor(priorityLevel){
    switch(priorityLevel){
        case 1:
            return 'red';
        case 2:
            return 'orange';
        case 3:
            return 'yellow';
        case 4:
            return 'yellow';
        case 5:
            return 'green';
        default:
            return 'gray';
    }
}